export default {
  namespaced: true,
  state: {
    getApplication: null,
    sendApplication: null,
    getFlow: null,
    sendFlow: null,
    flowGroup: null,
    userIntegration: null,
    userIntegrationFlow: null,
    isAdmin: false,
    isPartner: false,
    isTriggeredByWebhook: false,
    datamodelFields: [],
    conditions: {},
    actions: {},
    actionsNotMapped: {},
    operands: {},
    starts: {},
    ends: {},
    useDefaultFor: {},
    microfunctions: [],
    applyActionTo: {},
    useMicrofunctionWhen: {},
    executeRuleWhen: {},
    blockRules: {}
  },
  getters: {
    getApplication: state => state.getApplication,
    sendApplication: state => state.sendApplication,
    getFlow: state => state.getFlow,
    sendFlow: state => state.sendFlow,
    userIntegration: state => state.userIntegration,
    userIntegrationFlow: state => state.userIntegrationFlow,
    flowGroup: state => state.flowGroup,
    isAdmin: state => state.isAdmin,
    isPartner: state => state.isPartner,
    isTriggeredByWebhook: state => state.isTriggeredByWebhook,
    datamodelFields: state => state.datamodelFields,
    conditions: state => state.conditions,
    actions: state => state.actions,
    actionsNotMapped: state => state.actionsNotMapped,
    operands: state => state.operands,
    starts: state => state.starts,
    ends: state => state.ends,
    useDefaultFor: state => state.useDefaultFor,
    microfunctions: state => state.microfunctions,
    applyActionTo: state => state.applyActionTo,
    useMicrofunctionWhen: state => state.useMicrofunctionWhen,
    executeRuleWhen: state => state.executeRuleWhen,
    blockRules: state => state.blockRules,
  },
  mutations: {
    setFlowsData(state, payload) {
      Object.assign(state, payload);
    },
    SET_DATAMODEL_FIELDS(state, datamodelFields) {
      state.datamodelFields = datamodelFields;
    },
    SET_CONDITIONS(state, conditions) {
      state.conditions = conditions;
    },
    SET_ACTIONS(state, actions) {
      state.actions = actions;
    },
    SET_ACTIONS_NOT_MAPPED(state, actionsNotMapped) {
      state.actionsNotMapped = actionsNotMapped;
    },
    SET_OPERANDS(state, operands) {
      state.operands = operands;
    },
    SET_STARTS(state, starts) {
      state.starts = starts;
    },
    SET_ENDS(state, ends) {
      state.ends = ends;
    },
    SET_USE_DEFAULT_FOR(state, useDefaultFor) {
      state.useDefaultFor = useDefaultFor;
    },
    SET_MICROFUNCTIONS(state, microfunctions) {
      state.microfunctions = microfunctions;
    },
    SET_APPLYACTIONTO(state, applyActionTo) {
      state.applyActionTo = applyActionTo;
    },
    SET_USE_MICROFUNCTION_WHEN(state, useMicrofunctionWhen) {
      state.useMicrofunctionWhen = useMicrofunctionWhen;
    },
    SET_EXECUTE_RULE_WHEN(state, executeRuleWhen) {
      state.executeRuleWhen = executeRuleWhen;
    },
    SET_BLOCK_RULES(state, blockRules) {
      state.blockRules = blockRules;
    },
  },
  actions: {
    storeFlowsData({commit}, payload) {
      commit("setFlowsData", payload);
    },
    setDatamodelFields({commit}, datamodelFields) {
      commit("SET_DATAMODEL_FIELDS", datamodelFields);
    },
    setConditions({commit}, conditions) {
      commit("SET_CONDITIONS", conditions);
    },
    setActions({commit}, actions) {
      commit("SET_ACTIONS", actions);
    },
    setActionsNotMapped({commit}, actionsNotMapped) {
      commit("SET_ACTIONS_NOT_MAPPED", actionsNotMapped);
    },
    setOperands({commit}, operands) {
      commit("SET_OPERANDS", operands);
    },
    setStarts({commit}, starts) {
      commit("SET_STARTS", starts);
    },
    setEnds({commit}, ends) {
      commit("SET_ENDS", ends);
    },
    setUseDefaultFor({commit}, useDefaultFor) {
      commit("SET_USE_DEFAULT_FOR", useDefaultFor);
    },
    setMicrofunctions({commit}, microfunctions) {
      commit("SET_MICROFUNCTIONS", microfunctions);
    },
    setApplyActionTo({commit}, applyActionTo) {
      commit("SET_APPLYACTIONTO", applyActionTo);
    },
    setUseMicrofunctionWhen({commit}, useMicrofunctionWhen) {
      commit("SET_USE_MICROFUNCTION_WHEN", useMicrofunctionWhen);
    },
    setExecuteRuleWhen({commit}, executeRuleWhen) {
      commit("SET_EXECUTE_RULE_WHEN", executeRuleWhen);
    },
    setBlockRules({commit}, blockRules) {
      commit("SET_BLOCK_RULES", blockRules);
    },
  },
  modules: {},
};
